import styled from 'styled-components';

import { nepal } from '@paradigm/design-system/src/colors';

import { QuoteRow } from './QuotesRows';

interface ScreenBestFieldArgs {
  readonly sideLabel: string;
  readonly quantity: string;
  readonly price: string;
  readonly side: 'SELL' | 'BUY';
  readonly ivBestPrice: string;
}

export default function ScreenBestField({
  sideLabel,
  quantity,
  price,
  side,
  ivBestPrice,
}: ScreenBestFieldArgs) {
  return (
    <div>
      <Label>Screen Best {sideLabel}</Label>
      <ScreenBestQuoteRow
        quote={{ quantity, price, key: sideLabel, iv: ivBestPrice }}
        screenBestRow
        side={side}
      />
    </div>
  );
}

const ScreenBestQuoteRow = styled(QuoteRow)`
  border: 2px solid ${nepal}55;
  border-radius: 5px;
`;

const Label = styled.div`
  color: ${nepal};
  margin-bottom: 5px;
`;
